import {formatEther} from "viem";
import {useAccount} from "wagmi";
import {useSmeltWalletState, useMyCredits} from "@/hooks/useSmeltReads";
import {useRitualWrite} from "@/hooks/useRitualWrite";
import {SMELT_ABI} from "@/lib/abi";
import {SMELT_CONTRACT} from "@/lib/config";
import {TxStatus} from "./TxStatus";

/** RitualWallet balance + lock for the Smelt contract, plus the user's claimable credits. */
export function WalletPanel() {
  const {address} = useAccount();
  const ws = useSmeltWalletState();
  const creditsQ = useMyCredits();
  const credits = (creditsQ.data as bigint | undefined) ?? 0n;
  const {write, tx} = useRitualWrite();

  const locked = ws.currentBlock < ws.lockUntilBlock;

  async function onClaim() {
    await write({
      address: SMELT_CONTRACT,
      abi: SMELT_ABI,
      functionName: "claimCredits",
      gas: 120_000n,
      label: "Claim credits",
    });
  }

  return (
    <aside className="space-y-4">
      <div className="panel p-5">
        <p className="label mb-3">Smelt RitualWallet</p>
        <Row label="Balance" value={`${ws.balanceRitual} RITUAL`} />
        <Row
          label="Lock until"
          value={`block ${ws.lockUntilBlock.toString()}`}
          accent={locked ? "text-molten-300" : "text-forge-ash"}
        />
        <p className="mt-3 text-xs text-forge-ash">
          The contract holds its own balance and pays precompile fees from it as the
          scheduler payer.
        </p>
      </div>

      <div className="panel p-5">
        <p className="label mb-3">Your credits</p>
        <Row label="Claimable" value={`${formatEther(credits)} RITUAL`} accent="text-refined-cyan" />
        <button
          className="btn-ghost w-full mt-3 text-xs"
          onClick={() => onClaim().catch(() => {})}
          disabled={credits === 0n || !address}
        >
          Claim
        </button>
        <div className="mt-3">
          <TxStatus tx={tx} />
        </div>
      </div>
    </aside>
  );
}

function Row({label, value, accent = "text-forge-ash"}: {label: string; value: string; accent?: string}) {
  return (
    <div className="flex items-center justify-between text-sm py-1">
      <span className="text-forge-slag">{label}</span>
      <span className={`mono ${accent}`}>{value}</span>
    </div>
  );
}
